import { useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import api from '../api';
import '../admin.css';

const ALL_NAV = [
  { src: '/menu-bar-icon/Dashboard.png', label: 'Dashboard', path: '/admin/dashboard', permission: null },
  // { src: '/menu-bar-icon/License Key.png', label: 'License Keys', path: '/admin/dashboard/keys', permission: 'licenseKeys' },
  { src: '/menu-bar-icon/App Version.png', label: 'App Versions', path: '/admin/dashboard/versions', permission: 'appVersions' },
  { src: '/menu-bar-icon/Users.png', label: 'Users', path: '/admin/dashboard/users', permission: 'users' },
  { src: '/menu-bar-icon/Devices.png', label: 'Devices', path: '/admin/dashboard/devices', permission: 'devices' },
  { src: '/menu-bar-icon/Users.png', label: 'Roles', path: '/admin/dashboard/roles', permission: 'superAdminOnly' },
  { src: '/menu-bar-icon/Users.png', label: 'Tech Users', path: '/admin/dashboard/tech-users', permission: 'superAdminOnly' },
  { src: '/menu-bar-icon/License Key.png', label: 'Plans', path: '/admin/dashboard/plans', permission: 'superAdminOnly' },
  { src: '/menu-bar-icon/License Key.png', label: 'Payments', path: '/admin/dashboard/payments', permission: 'superAdminOnly' },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem('adminInfo') || '{}');
  const isSuperAdmin = admin.role === 'admin';

  const navItems = ALL_NAV.filter(item => {
    if (item.permission === null) return true;
    if (item.permission === 'superAdminOnly') return isSuperAdmin;
    if (isSuperAdmin) return true;
    return (admin.permissions || []).includes(item.permission);
  });

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const activeItem = navItems.find((item) =>
    item.path === '/admin/dashboard'
      ? location.pathname === '/admin/dashboard' || location.pathname === '/admin/dashboard/'
      : location.pathname.startsWith(item.path)
  ) || navItems[0];

  const handleLogout = async () => {
    try { await api.post('/admin/logout'); } finally {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminInfo');
      navigate('/admin/login');
    }
  };

  return (
    <div className="admin-root">
      {sidebarOpen && (
        <div className="admin-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="brand">
          {/* <div className="brand-icon">Csf</div> */}
          <img src="/Cloud security firewall logo.png" alt="Logo" />
          <span className="brand-text">Shield Secure</span>
        </div>
        <nav className="admin-nav">
          {navItems.map(({ src, label, path }) => (
            <div
              key={label}
              className={`nav-item${activeItem.label === label ? ' active' : ''}`}
              onClick={() => { navigate(path); setSidebarOpen(false); }}
            >
              {/* <span className="nav-icon">{src}</span> */}
              <img src={src} alt={label} />
              <span>{label}</span>
            </div>
          ))}
        </nav>
      </aside>

      {/* Main */}
      <div className="admin-main">
        {/* Topbar */}
        <header className="topbar">
          <div className="topbar-left">
            <button className="menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
            <span className="page-title">{activeItem.label}</span>
          </div>
          <div className="topbar-right">
            {/* <div className="notif-bell">
              <span>🔔</span>
              <span className="notif-dot">3</span>
            </div> */}
            <div className="admin-info-wrap">
              <div className="avatar">{(admin.name || 'A')[0].toUpperCase()}</div>
              <span className="admin-name-text">{admin.name || admin.email}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>Logout</button>
          </div>
        </header>

        {/* Content */}
        <div className="content">
          <div className="breadcrumb">
            <span className="bread-home">Home</span>
            <span className="bread-sep"> / </span>
            <span>{activeItem.label}</span>
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}
